import React from "react";

function Vision() {
  return (
    <section className="tc-about-style7 pt-0">
      <div className="container">
        <div className="row gx-0 justify-content-between">
        <h2 className="fsz-45 fw-500 text-center">
          {/* BDA */}
          <span className="sub-font fst-italic color-orange1 fw-400 ms-2">
          Vision
          </span>
        </h2>
          <div className="col-lg-12">
            <div className="info wow fadeInUp slow" data-wow-delay="0.2s">
              <div className="text fsz-20 fw-500 mb-20 text-center mt-3">
              " BDA : Crafting bold, sustainable spaces that inspire and unite people."  
              </div>
            </div>
          </div>
          
        </div>
      </div>
    </section>
  );
}

export default Vision;


